var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.vif)?_c('div',{staticClass:"alert alert-danger w-100 mt-3",domProps:{"textContent":_vm._s(_vm.vtext)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }